import { Button, NotFound } from '@totalsoft/rocket-ui'
import { Grid2 as Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'

const CustomNotFound = () => {
  const { t } = useTranslation()
  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <NotFound text={t('PageNotFound.Title')} details={t('PageNotFound.Details')} />
      </Grid>
      <Grid size={12} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button variant='contained' href='/' size='large' color='primary'>
          {t('ReturnToChat')}
        </Button>
      </Grid>
    </Grid>
  )
}

export default CustomNotFound
